<template>
  <div class="c-links-settings">
    <settings-header
      :with-back-button="!!path"
      @back="changePath(null)"
      :title="getPanelTitle"
    />
    <div class="c-links-settings__container">
      <template v-if="!path">
        <r-simple-list
          :list="tabs"
          @click-handler="e => changePath(e.id)"
          :with-bg="true"
        />
      </template>
      <template v-else-if="path === 'settings'">
        <color-control
          :id="id"
          :config="stylesConfigs.style.paint"
          color-field="line-color"
          opacity-field="line-opacity"
        />
        <width-control
          :id="id"
          :config="stylesConfigs.style.paint"
          field="line-width"
        />
        <popup-control :id="id" />
      </template>
      <template v-else-if="path === 'diagram'">
        <diagram-control :id="id" />
      </template>
    </div>
  </div>
</template>

<script>
import SettingsHeader from "../../settings-header/settings-header";
import ColorControl from "../controls/color";
import WidthControl from "../controls/width";
import PopupControl from "../controls/popup";
import DiagramControl from "../controls/diagram";

const tabs = [
  {
    id: "settings",
    title: "Общие настройки",
    subtitle: "Настройка цвета, обводки, размеров",
    icon: "stylize"
  },
  {
    id: "diagram",
    title: "Эпюры",
    subtitle: "Отображение и настройка эпюр",
    icon: "epure"
  }
];

export default {
  props: {
    id: {
      type: String,
      required: true
    }
  },
  components: {
    SettingsHeader,
    ColorControl,
    WidthControl,
    PopupControl,
    DiagramControl
  },
  data() {
    return {
      path: null,
      tabs
    };
  },
  computed: {
    stylesConfigs() {
      return this.$store.state.calculations.stylesConfigs[this.id];
    },
    getPanelTitle() {
      switch (this.path) {
        case "settings":
          return "Общие настройки";
        case "diagram":
          return "Настройки эпюр";
        default:
          return "Параметры слоя";
      }
    }
  },
  methods: {
    changePath(path) {
      this.path = path;
    }
  }
};
</script>

<style lang="scss">
.c-links-settings {
  flex: 1;
  display: flex;
  flex-direction: column;

  &__container {
    display: flex;
    flex-direction: column;
    flex: 1;
    height: 0px;
    padding: 8px;
  }
}
</style>
